// @ts-ignore
import AuthActions from 'auth/AuthActions';
import { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

type onEnterHandler = (state: RouterState, replace: (location: LocationDescriptor) => void) => void;

const RequireLoginWithAuthToken: onEnterHandler = async (state, replace) => {
  // Only logout the current user if they have an auth token to sign back in with.
  if (state.location.query['auth_token']) {
    await AuthActions.signoutWithoutRedirect();
    await AuthActions.accessTokenSignIn(state.location.query['auth_token']);
  }
};

export default RequireLoginWithAuthToken;
